"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'c_tab_input',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    },
    index: {
      type: null
    },
    isRub: {
      type: Boolean,
      default: false
    }
  },
  components: {
    draggable: _vuedraggable.default
  },
  data: function data() {
    return {
      tabVal: '',
      defaults: {},
      configData: {},
      menus: [],
      list: [{
        title: '',
        val: ''
      }],
      modalPic: false,
      isChoice: '单选',
      gridBtn: {
        xl: 4,
        lg: 8,
        md: 8,
        sm: 8,
        xs: 8
      },
      gridPic: {
        xl: 6,
        lg: 8,
        md: 12,
        sm: 12,
        xs: 12
      },
      activeIndex: 0,
      indexLast: 0,
      lastObj: {},
      linkList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.defaults = _this.configObj;
      _this.configData = _this.configObj[_this.configNme];
      _this.activeIndex = _this.configData.tabVal;
      _this.tabVal = _this.configData.list[0].val;
    });
  },
  watch: {
    configObj: {
      handler: function handler(nVal, oVal) {
        this.defaults = nVal;
        this.configData = nVal[this.configNme];
      },
      deep: true
    },
    activeIndex: function activeIndex(nVal) {
      this.tabVal = this.configData.list[nVal].val;
    }
  },
  methods: {
    onInput: function onInput(value) {
      this.configData.list[this.activeIndex].val = value;
    },
    onChecked: function onChecked(item, index) {
      this.activeIndex = index;
      this.tabVal = item.val;
      this.$emit('getConfig', {
        name: 'tab_input',
        values: index
      });
    },
    addBox: function addBox() {
      this.activeIndex += 1; //默认选中新填的tab
      this.configData.list.push({
        val: '选项卡'
      });
      this.$emit('getConfig', {
        name: 'add_tab',
        values: this.configData.list
      });
    },
    onBlur: function onBlur() {
      var data = this.defaults.menuConfig;
      this.defaults.picStyle.picList[this.defaults.picStyle.tabVal].link = data.list[0].info[0].val;
    },
    // 删除
    bindDelete: function bindDelete(index) {
      this.configData.list.splice(index, 1);
      this.$emit('getConfig', {
        name: 'del_tab',
        values: this.configData.list,
        index: index
      });
    }
  }
};